<template>
    <div id="app" class="app">
    <app-header fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" :to="{name: 'home'}">
        <img class="navbar-brand-full" src="/images/brand/home.svg" width="89" height="25" alt="Admin Service">
        <img class="navbar-brand-minimized" src="/images/brand/mansion.svg" width="30" height="30" alt="Admin Service">
      </b-link>
      <SidebarToggler v-show="showSideBarToggler" ref="toggle" class="d-md-down-none" />
      <b-navbar-nav class="d-md-down-none">
        <b-nav-item-dropdown v-show="havePermission(permission.admin101)" class="px-3" :text="text.oneService">
          <b-dropdown-item :to="{name: 'news'}">News</b-dropdown-item>
          <b-dropdown-item :to="{name: 'privilege'}">Privilage</b-dropdown-item>
          <b-dropdown-item :to="{name: 'reward'}">Reward</b-dropdown-item>
          <b-dropdown-item :to="{name: 'summary'}">Summary</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item :to="{name: '101shops-home'}">Shops</b-dropdown-item>
          <b-dropdown-item :to="{name: '101zones-home'}">Zones</b-dropdown-item>
          <b-dropdown-item :to="{name: '101categories-home'}">Categories</b-dropdown-item>
          <b-dropdown-item :to="{name: '101floors-home'}">Floors</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown v-show="havePermission(permission.adminOneApp)" class="px-3" :text="text.oneApp">
          <b-dropdown-item :to="{name: 'announcement-home'}">{{text.announcement}}</b-dropdown-item>
          <b-dropdown-item :to="{name: 'home-automation'}">{{text.homeAutomationGateways}}</b-dropdown-item>
          <b-dropdown-item :to="{name: 'one_app_profiles'}">{{text.userProfiles}}</b-dropdown-item>
          <b-dropdown-item :to="{name: 'one_app_residents'}">{{text.residents}}</b-dropdown-item>
          <b-dropdown-item :to="{name: 'one_app_projects'}">{{text.projects}}</b-dropdown-item>
          <b-dropdown-item :to="{name: 'one_app_messaging'}">{{text.messaging}}</b-dropdown-item>
          <b-dropdown-item :to="{name: 'one_app_service-request'}">{{text.serviceRequest}}</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown class="px-3" :text="'Facility'">
          <b-dropdown-item :to="{name: 'apps2'}">App Store</b-dropdown-item>
          <b-dropdown-item v-show="havePermission(permission.messaging)" :to="{name: 'messaging'}">{{text.messaging}}</b-dropdown-item>
          <b-dropdown-item v-show="havePermission(permission.developer)" to="/jwt">{{text.jwt}}</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item class="px-3" to="/docs" exact>{{text.docs}}</b-nav-item>
        <b-nav-item v-show="havePermission(permission.userManagement)" class="px-3" to="/users">{{text.users}}</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown :text="$language">
          <b-dropdown-item @click="switchLanguage('TH')">{{text.languageTH}}</b-dropdown-item>
          <b-dropdown-item @click="switchLanguage('EN')">{{text.languageEN}}</b-dropdown-item>
        </b-nav-item-dropdown>
        <AccountDropdown/>
      </b-navbar-nav>
      <AsideToggler class="d-none d-lg-block" v-if="havePermission(permission.admin)" />
    </app-header>
    <!-- Body -->
    <div class="app-body text-left">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
          <Breadcrumb :list="list"/>
          <div class="container-fluid">
            <router-view />
          </div>
        </main>
      <AppAside fixed>
          <Aside></Aside>
      </AppAside>
      </div>
      <!-- Footer -->
      <TheFooter>
        <div>
          <a href="http://localhost:8080">Dashboard</a>
          <span class="ml-1">&copy; 2020 Mobile Team.</span>
        </div>
        <div class="ml-auto">
          <span class="mr-1">Powered by</span>
          <a href="http://localhost:8080">Mobile Development Team.</a>
        </div>
    </TheFooter>
  </div>
</template>

<script>
import { Header as AppHeader,
  SidebarToggler,
  AsideToggler,
  Sidebar as AppSidebar,
  SidebarHeader,
  SidebarForm,
  SidebarNav,
  SidebarFooter,
  SidebarMinimizer,
  Breadcrumb,
  Aside as AppAside,
  Footer as TheFooter } from '@coreui/vue';
import { nav } from './nav/nav';
import AccountDropdown from '../components/AccountDropdown';
import permission from '../permission';
import { currentUser } from '../assets/utils/user';
import Aside from '../components/Aside';
import { navReformat } from '../assets/utils/formatter';
import { textMenu } from '../assets/utils/language';

export default {
  data () {
    return {
      nav: [],
      permission: permission,
      showSideBarToggler: true,
      text: {}

    };
  },
  components: {
    AppHeader,
    SidebarToggler,
    AsideToggler,
    AppSidebar,
    SidebarHeader,
    SidebarForm,
    SidebarNav,
    SidebarFooter,
    SidebarMinimizer,
    AppAside,
    TheFooter,
    Breadcrumb,
    AccountDropdown,
    Aside
  },
  computed: {
    list () {
      let appname = this.getBaseName();
      if ('apps' === appname) {
        return this.$route.matched.filter((route) => {
          if ('appdetails' === route.meta.label || 'home' === route.meta.label) {
            return '';
          } else if ('appdetailname' === route.meta.label) {
            route.meta.label = route.meta.label.replace('appdetailname', this.getAppDetailName());
            return route.meta.label;
          } else {
            return route.name || route.meta.label;
          }
        });
      }
      return this.$route.matched.filter((route) => route.name || route.meta.label);
    }
  },
  mounted () {
    this.text = textMenu(this.$language);
    this.refreshNavBar();
  },
  watch: {
    $route (to, from) {
      this.refreshNavBar();
    },
    $language: function () {
      this.text = textMenu(this.$language);
      this.refreshNavBar();
    }
  },
  methods: {
    getAppDetailName () {
      let app = JSON.parse(sessionStorage.getItem('app'));
      if (app) {
        return app.platform + '-' + app.name;
      }
    },
    refreshNavBar () {
      // set breadcrumb
      let name = this.getBaseName();
      this.nav = nav[name];
      this.nav = this.nav.map(n => {
        switch (n.name) {
          case 'Index':
          case 'หน้าหลัก':
          case 'Home':
            n.name = this.text.index;
            break;
          case 'Create':
          case 'สร้าง':
            n.name = this.text.create;
            break;
          case 'Add Resident':
          case 'เพิ่มลูกบ้าน':
            n.name = this.text.addResident;
            break;
          case 'Add Project':
          case 'เพิ่มโครงการ':
            n.name = this.text.addProject;
            break;
          case 'Setting':
          case 'ตั้งค่า':
            n.name = this.text.setting;
            break;
          case 'History':
          case 'ประวัติ':
            n.name = this.text.history;
            break;
          case 'register user':
          case 'ลงทะเบียนผู้ใช้':
            n.name = this.text.registerUser;
            break;
          case 'permission':
          case 'การเข้าถึง':
            n.name = this.text.permission;
            break;
          case 'App List':
          case 'รายชื่อแอพ':
            n.name = this.text.appList;
            break;
          case 'Create App':
          case 'สร้างแอพ':
            n.name = this.text.createApp;
            break;
          case 'API Key':
          case 'เอพีไอคีย์':
            n.name = this.text.apiKey;
            break;
          case 'User Token':
          case 'โทเคนผู้ใช้':
            n.name = this.text.userToken;
            break;
          case 'Send Notification':
          case 'ส่งการแจ้งเตือน':
            n.name = this.text.sendNotification;
            break;
        }
        return n;
      });

      if ('docs' === name) {
        this.getDynamicNavDoc();
      }
      /**   set sidebar toggler
       *   This is for example to toggle sidebar
      if ('news' === name) {
        if (this.$refs.toggle) {
          this.$refs.toggle.toggle(false);
        }

        this.showSideBarToggler = false;
      } else {
        this.showSideBarToggler = true;
      }
      */
    },
    switchLanguage (language) {
      this.$language = language;
      localStorage.setItem('language', language);
      // this.$router.go();
    },
    getBaseName () {
      let name = this.$route.name;
      name = '' === name ? 'home' : name;
      let split = name.split('-');
      if (split.length > 1) {
        name = split[0];
      }
      return name;
    },
    havePermission (condition) {
      const user = currentUser();
      if (user) {
        return -1 !== user.permission.indexOf(condition);
      } else {
        return false;
      }
    },
    getDynamicNavDoc () {
      const navDoc = nav['docs'];
      this.axios.get(process.env.VUE_APP_URL_DOCS_API + '/docs')
        .then(response => {
          const data = response.data.data;
          const navArchitecture = navReformat(data.docs, 'architecture');
          const navDeployment = navReformat(data.docs, 'deployment');
          const navAPI = navReformat(data.docs, 'api');
          const navInstallation = navReformat(data.docs, 'installation');
          const navTutorial = navReformat(data.docs, 'toturial');
          navDoc.forEach(nav => {
            if ('architecture' === nav.id) {
              navArchitecture <= 0 ? delete nav.children : nav.children = navArchitecture;
            } else if ('deployment' === nav.id) {
              navDeployment <= 0 ? delete nav.children : nav.children = navDeployment;
            } else if ('api' === nav.id) {
              navAPI <= 0 ? delete nav.children : nav.children = navAPI;
            } else if ('installation' === nav.id) {
              navInstallation <= 0 ? delete nav.children : nav.children = navInstallation;
            } else if ('tutorial' === nav.id) {
              navTutorial <= 0 ? delete nav.children : nav.children = navTutorial;
            }
          });
          this.nav = navDoc;
        })
        .catch(error => {
          console.log(error);
          this.nav = [];
        });
    }
  }
};
</script>
